import { useEffect } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import LandingPage from "@/pages/LandingPage";
import { Toaster } from "@/components/ui/sonner";

function App() {
  useEffect(() => {
    // Update document title and meta description
    document.title = "Eknoor Driving School - G2 & G Road Test Prep Across the GTA";
    const desc = document.querySelector('meta[name="description"]');
    if (desc) {
      desc.setAttribute(
        "content",
        "Eknoor Driving School offers G2 and G lessons, package pricing, BDE course options, and road-test car service across the GTA and surrounding area. Call or text +1 (905) 906-7361."
      );
    }
  }, []);

  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<LandingPage />} />
          <Route path="*" element={<LandingPage />} />
        </Routes>
      </BrowserRouter>
      <Toaster position="bottom-center" />
    </div>
  );
}

export default App;
